export default {"src":"/_next/static/media/spinach-paw.acf31e82.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};